import React from "react";

const AccomodationSchema = () => (
    <React.Fragment>
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(
                    {
                        "@context": "https://schema.org",
                        "@type": "Apartment",
                        "name": "The Twin Towers Hotel",
                        "description": "One of the best hotel in Kufri, it is located in the heart of town, amid the Himalayan foothills. The location is a beautiful retreat in a mountainous neighborhood, offering visitors a tranquil, calm, and pleasant atmosphere for a soul-filling holiday, and being so near to nature offers a choice of activities that will nourish your spirit. It will undoubtedly assist you in unwinding while you participate in the most exciting activities with your loved ones at and around the resort, since it is a great site for fun activities such as adventure sports, walks and trails, and so on.",
                        "numberOfRooms": 3,
                        "occupancy": {
                            "@type": "QuantitativeValue",
                            "minValue": 1,
                            "maxValue": 4
                        },
                        "floorLevel": 5,
                        "floorSize": {
                            "@type": "QuantitativeValue",
                            "value": 81,
                            "unitCode": "MTK"
                        },
                        "numberOfBathroomsTotal": 2,
                        "numberOfBedrooms": 2,
                        "petsAllowed": true,
                        "tourBookingPage": "",
                        "yearBuilt": 2014,
                        "telephone": "+91 07807885113",
                        "address": {
                            "@type": "PostalAddress",
                            "addressCountry": "IN",
                            "addressLocality": "NH 05, New kufri, Galu, Hills",
                            "addressRegion": "Indian Himalayan Region",
                            "postalCode": "171209",
                            "streetAddress": "NH 05, New kufri, Galu, Hills"
                        },
                        "latitude": 31.100830,
                        "longitude": 77.264710

                    }
                )
            }}
        />
    </React.Fragment>
);

export default AccomodationSchema;